import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TValidateAddCardTokenRequestSchema,
  TValidateAddCardTokenResponseSchema,
} from "./validateAddCardToken.schema";

export const validateAddCardToken = (axios: IAxiosInstance) => {
  return async (query: TValidateAddCardTokenRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TValidateAddCardTokenResponseSchema>
    >(`/push-to-card/validate-add-card-token`, {
      params: query,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
